import * as React from 'react'
import OtaReservationDetailLayout from './layout'
import { utilService } from '../../../core/services'
import SidebarLayout from '../_layouts/sidebarLayout'
import Panel from 'components/atoms/Panel'
import styled from 'styled-components'
import LinkButton from 'components/atoms/LinkButton'
import SvgIcon from 'components/atoms/SvgIcon'
import I18n from 'core/i18n'
import { IOtaReservationProps } from 'utils/otaReservation/useOtaReservation'

const Show: React.FC<IOtaReservationProps> = props => {
  const { data: currentUser } = utilService.getDataFromJson(props.user)

  return (
    <SidebarLayout user={currentUser}>
      <NoPaddingTopPanel marginType="dashboard" noDecoration={true}>
        <BackButton>
          <LinkButton href={`/agent/ota_reservations`}>
            <>
              <SvgIcon
                name="keyboard_arrow_left"
                className="icon"
                ariaHidden={true}
                role="presentation"
              />
              {I18n.t('generic.back_to_index')}
            </>
          </LinkButton>
        </BackButton>
        <OtaReservationDetailLayout props={props} />
      </NoPaddingTopPanel>
    </SidebarLayout>
  )
}

export default Show

const NoPaddingTopPanel = styled(Panel)`
  overflow: clip;
  && > .Panel_Body {
    padding-top: 0;
  }
  @media screen and (max-width: 1600px) {
    &.dashboard {
      padding: 20px 40px;
    }
  }
`

const BackButton = styled.div`
  padding-bottom: 16px;
`
